/**
 * Custom Options Block
 * - Handles radio-button selection (same markup as theme variant picker)
 * - Handles dropdown selection
 * - Syncs selected value to hidden line item property input
 * - Updates cart note attributes for order tagging
 * - Reacts to variant:change – marks all options as sold-out when variant is unavailable
 */
(function () {
  'use strict';

  function init() {
    initRadioGroups();
    initDropdowns();
    initVariantListener();
  }

  /* ---------- Ensure hidden input lives inside the product form ---------- */
  function ensureInsideForm(hiddenInput) {
    if (!hiddenInput) return;
    var formId = hiddenInput.getAttribute('form');
    if (!formId) return;
    var form = document.getElementById(formId);
    if (form && !form.contains(hiddenInput)) {
      form.appendChild(hiddenInput);
    }
  }

  function findDisplaySpan(blockId) {
    return document.querySelector('[data-custom-option-selected="' + blockId + '"]');
  }

  /* ---------- Radio / Swatch Button Mode ---------- */
  function initRadioGroups() {
    document.querySelectorAll('[data-custom-options-group]').forEach(function (group) {
      if (group._customOptsBound) return;
      group._customOptsBound = true;

      var targetId = group.getAttribute('data-target');
      var hiddenInput = targetId ? document.getElementById(targetId) : null;
      var title = group.getAttribute('data-option-title');
      var tagOrder = group.getAttribute('data-tag-order');

      ensureInsideForm(hiddenInput);

      group.querySelectorAll('input[type="radio"][data-custom-option-value]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.classList.contains('disabled')) return;

          var value = radio.value;
          if (hiddenInput) hiddenInput.value = value;

          var displaySpan = group.querySelector('[data-custom-option-selected]');
          if (displaySpan) displaySpan.textContent = value;

          if (tagOrder !== 'false') {
            syncCartAttribute(title, value);
          }
        });
      });

      // Initial cart attribute sync for preselected option
      if (tagOrder !== 'false' && hiddenInput && hiddenInput.value) {
        syncCartAttribute(title, hiddenInput.value);
      }
    });
  }

  /* ---------- Dropdown Mode ---------- */
  function initDropdowns() {
    document.querySelectorAll('[data-custom-options-select]').forEach(function (select) {
      if (select._customOptsBound) return;
      select._customOptsBound = true;

      var targetId = select.getAttribute('data-target');
      var hiddenInput = targetId ? document.getElementById(targetId) : null;
      var blockId = select.getAttribute('data-selected-display');

      ensureInsideForm(hiddenInput);

      select.addEventListener('change', function () {
        var value = select.value;
        if (hiddenInput) hiddenInput.value = value;

        if (blockId) {
          var displaySpan = findDisplaySpan(blockId);
          if (displaySpan) displaySpan.textContent = value;
        }

        var tagOrder = select.getAttribute('data-tag-order');
        if (tagOrder !== 'false') {
          var title = select.getAttribute('data-option-title');
          syncCartAttribute(title, value);
        }
      });

      // Initial cart attribute sync for preselected option
      var tagOrder = select.getAttribute('data-tag-order');
      if (tagOrder !== 'false' && hiddenInput && hiddenInput.value) {
        var title = select.getAttribute('data-option-title');
        syncCartAttribute(title, hiddenInput.value);
      }
    });
  }

  /* ---------- Variant Availability Listener ---------- */
  function onVariantChange(e) {
    var variant = e.detail && e.detail.variant;
    var isAvailable = variant && variant.available;
    setCustomOptionsDisabled(!isAvailable);
  }

  function setCustomOptionsDisabled(isDisabled) {
    document.querySelectorAll('[data-custom-options-group]').forEach(function (group) {
      group.querySelectorAll('input[type="radio"][data-custom-option-value]').forEach(function (radio) {
        if (isDisabled) {
          radio.classList.add('disabled');
        } else {
          radio.classList.remove('disabled');
        }
      });
    });
    document.querySelectorAll('[data-custom-options-select]').forEach(function (select) {
      select.disabled = isDisabled;
    });
  }

  function initVariantListener() {
    if (window._customOptsVariantBound) return;
    window._customOptsVariantBound = true;

    // Initial sold-out state is set server-side via Liquid (.disabled class / disabled attr).
    // The theme dispatches variant:change on the product form (not document), and it doesn't bubble.
    // Listen on all product forms + document as fallback.
    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      form.addEventListener('variant:change', onVariantChange);
    });
    document.addEventListener('variant:change', onVariantChange);
  }

  /* ---------- Cart Attribute Sync (Order Tagging) ---------- */
  function syncCartAttribute(title, value) {
    if (!title) return;

    var body = { attributes: {} };
    body.attributes[title] = value;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function (err) {
      console.warn('[Custom Options] Cart attribute sync failed:', err);
    });
  }

  /* ---------- Bootstrap ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section re-render (Theme Editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
